import { all, takeEvery, put, call, takeLatest } from 'redux-saga/effects'
import { notification, message } from 'antd'
import { history } from 'index'
import store from 'store'
import * as jwt from 'services/jwt'
import * as onBoarding from 'services/onBoarding'
import actions from './actions'

const mapAuthProviders = {
  login: jwt.login,
  register: jwt.register,
  currentAccount: jwt.currentAccount,
  logout: jwt.logout,
  validateOnBoarding: onBoarding.onBoardingDone,
  confirm: onBoarding.sendConfirmationEmail,
}

export function* LOGIN({ payload }) {
  const { email, password } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const success = yield call(mapAuthProviders.login, email, password)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    yield history.push('/')
    notification.success({
      message: 'Logged In',
      description: 'You have successfully logged in!',
    })
  }
  if (!success) {
    notification.warn({
      message: 'Error during login',
      description: 'Please check username and password',
    })
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* REGISTER({ payload }) {
  console.log('Payload from register', payload)
  const { email, password, firstName, lastName } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const success = yield call(mapAuthProviders.register, email, password, firstName, lastName)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    yield history.push('/')
    notification.success({
      message: 'Success !!!',
      description: 'You have successfully registered.',
    })
  } else {
    // Error with user registration
    // see error interceptor to check why registration didn't work
    notification.warn({
      message: 'This user already exists',
      description: 'please try again !',
    })
    // Stop loading
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

// LOAD THE CURRENT SESSION EDIT IF NEEDED MORE INFO ON USER
export function* LOAD_CURRENT_ACCOUNT() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { user } = yield call(mapAuthProviders.currentAccount)
  if (user) {
    const {
      id,
      email,
      fName,
      lName,
      mailSubscription,
      status,
      phone,
      avatar,
      role,
      onBoardingDone,
      subscriptionPlan,
      creationDate,
    } = user
    yield put({
      type: 'user/SET_STATE',
      payload: {
        id,
        email,
        fName,
        lName,
        name: `${fName || 'John'} ${lName || 'Doe'}`,
        avatar,
        phone,
        status,
        role,
        onBoardingDone,
        subscriptionPlan,
        creationDate,
        mailSubscription,
        authorized: true,
      },
    })
  }
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* LOGOUT() {
  yield call(mapAuthProviders.logout)
  yield put({
    type: 'user/RESET',
  })
}

export function* ON_BOARDING_DONE() {
  const success = yield call(mapAuthProviders.validateOnBoarding, true)
  if (success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        onBoardingDone: true,
      },
    })
    store.set('onBoarding', true)
    message.success('On Boarding completed', 1.5, yield history.push('/dashboard'))
  } else {
    notification.error({
      message: 'Error during onboarding validation',
      description: 'Please try again',
    })
  }
}

export function* CONFIRMATION_EMAIL() {
  const success = yield call(mapAuthProviders.confirm)
  if (success) {
    notification.success({
      message: 'Email successfuly sent',
    })
  } else {
    notification.error({
      message: 'Error during email confirmation',
      description: 'Please try again',
    })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.REGISTER, REGISTER),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),
    takeLatest(actions.ON_BOARDING_DONE, ON_BOARDING_DONE),
    takeLatest(actions.CONFIRMATION_EMAIL, CONFIRMATION_EMAIL),
    store.get('authToken') ? LOAD_CURRENT_ACCOUNT() : null, // run once on app load to check user auth
  ])
}
